import aboutImg from '../../assets/img/home4/about.webp';

const AboutFour = () => {
    return (
        <>
            <div className="our-agency-about-wrapper section-padding pb-0">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6">
                            <div className="agency-img">
                                <img src={aboutImg} alt="DH Tech About" loading="lazy" width="570" height="600" />
                            </div>
                        </div>
                        <div className="col-xl-6 ps-xl-5 mt-5 mt-xl-0">
                            <div className="about-agency-content">
                                  <div className="block-contents">
                            <div className="section-title">
                                {/* <h5>Service</h5> */}
                                <span>Why Choose us</span>
                                <h2>Why Clients Choose Us</h2>
                            </div>
                        </div>
                                {/* <div className="experience-video-play d-flex">
                                    <div className="year-experience-about d-flex align-items-center">
                                        <div className="year">
                                            <h3>18</h3>
                                        </div>
                                        <div className="text">
                                            <p>Years <br /> Experience</p>
                                        </div>
                                    </div>
                                    <div className="video-popup-btn d-flex align-items-center">
                                        <div className="video-play-btn">
                                            <span className="popup-video" onClick={() => setOpen(true)} style={{cursor: 'pointer'}}><i className="fas fa-play"></i></span>
                                            <span>Watch our activities for your
                                            agency growth</span>                     
                                        </div>
                                    </div>
                                </div> */}
                                <div className="checked-features-list theme-color-4">
                                    <ul>
                                        <li>Quick Response </li>
                                        <li>Experienced Technicians</li>
                                        <li>Affordable Pricing</li>
                                        <li>All Services Under One Roof</li>
                                        <li>Serving Across UAE</li>
                                    </ul>
                                </div>

                                <a
                                    href="https://wa.me/971502033924"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="theme-btn mt-30 mb-5"
                                >
                                    Get a Free Inspection Today
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* About CTA Section */}
            <div className="about-cta-section">
                <div className="container">
                    <div className="about-cta-inner">
                        <h3 className="about-cta-heading">Need Maintenance or Renovation Service Today?</h3>
                        <div className="about-cta-buttons">
                            <a
                                href="tel:+971502033924"
                                className="about-cta-btn about-cta-call"
                            >
                                <i className="fas fa-phone"></i>
                                 Call Now for Immediate Assistance
                            </a>
                            <a
                                href="https://wa.me/971502033924"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-cta-btn about-cta-whatsapp"
                            >
                                <i className="fab fa-whatsapp"></i>
                                 WhatsApp Us for Quick Quote
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutFour;